import { DenormalizedCustomizableQuestion } from '@packages/types'
import React from 'react'

import useThemeSettings from 'customizer/theme/useThemeSettings'
import WarningIcon from 'icons/bold/47-Transportation/27-Signs/road-sign-warning.svg'
import CommonTextQuestion from 'themes/common/components/questions/TextQuestion'

import './TextQuestion.scss'

export interface TextQuestionProps {
  question: DenormalizedCustomizableQuestion
  focusQuestion?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
  createTextAnswer: (id: string, value: string, cleanedValue: string | undefined) => void
  updateTextAnswer: (id: string, selectedAnswerId: string, value: string, cleanedValue: string | undefined) => void
  requiredWarning?: boolean
}

const TextQuestion = (props: TextQuestionProps) => {
  const style = useThemeSettings('textInputAndDropdown')

  return (
    <CommonTextQuestion
      {...props}
      minRows={2}
      maxRows={7}
      onFocus={props.focusQuestion}
      textInputAndDropdownStyle={style}
      className={props.requiredWarning || props.question.hasFilteredWord ? 'error' : ''}
    >
      {(props.requiredWarning || props.question.hasFilteredWord) && <WarningIcon className="icon warning" />}
    </CommonTextQuestion>
  )
}

export default TextQuestion
